<template>
  <aha-context-menu ref="context-menu-actions">
    <h5 class="break-words context-menu-header">
      {{ presentation.name }}
    </h5>
    <ul>
      <li
        class="context-menu-item"
        :class="{disabled: isDisableEditPresentation}"
        @click="handleSlideUpMenuClick('private', $event)"
        v-if="!isGuestUser"
      >
        <aha-icon
          class="text-base-70"
          v-if="presentation.privateMode"
          name="hide"
          viewBox="0 0 24 24"
          width="20"
          height="20"
          v-tooltip="'Private: Audience cannot see or interact with your slides'"
        />

        <aha-icon
          class="text-base-70"
          v-else
          name="unhide"
          viewBox="0 0 24 24"
          width="20"
          height="20"
          v-tooltip="'Public: Audience can see and interact with your slides'"
        />
        <span>{{ presentation.privateMode ? 'Public' : 'Private' }}</span>
      </li>
      <li
        class="context-menu-item"
        :class="{disabled: isDisableEditPresentation}"
        @click="handleSlideUpMenuClick('rename', $event)"
        v-if="!isGuestUser"
      >
        <aha-icon
          class="text-base-70"
          name="edit"
          viewBox="0 0 24 24"
          width="20"
          height="20"
          style="position: relative; left: 1px"
        />
        <span>Rename</span>
      </li>
      <li
        class="context-menu-item"
        @click="handleSlideUpMenuClick('shareToEdit', $event)"
        v-if="isInviteToEditVisible"
      >
        <aha-icon
          class="text-base-70"
          name="invite"
          width="20"
          height="20"
          viewBox="0 0 16 16"
        />
        <span>Invite to edit</span>
      </li>
      <li
        class="context-menu-item"
        @click="handleSlideUpMenuClick('share', $event)"
      >
        <aha-icon
          class="text-base-70"
          name="share"
          viewBox="0 0 24 24"
          width="20"
          height="20"
        />
        <span>Share</span>
      </li>
      <div class="my-2 border-b border-secondary-20" />
      <li
        class="context-menu-item"
        @click="handleSlideUpMenuClick('results', $event)"
      >
        <aha-icon
          class="text-base-70"
          name="download"
          viewBox="0 0 24 24"
          width="20"
          height="20"
        />
        <span>Results</span>
      </li>
      <li
        class="context-menu-item"
        @click="handleSlideUpMenuClick('setting', $event)"
      >
        <aha-icon
          class="text-base-70"
          name="setting"
          viewBox="0 0 24 24"
          width="20"
          height="20"
        />
        <span>Setting</span>
      </li>
      <div class="my-2 border-b border-secondary-20" />
      <li
        class="flex context-menu-item border-secondary-20"
        v-if="!isPresenterWhiteLabel"
      >
        <a
          class="flex w-full px-0 context-menu-item"
          href="https://help.ahaslides.com/"
          target="_blank"
          v-tooltip="tooltipHelp"
          @click="clickHelpContext"
        >
          <aha-icon
            class="text-base-70"
            name="question"
            width="20"
            height="20"
            viewBox="0 0 24 24"
          />
          <span
            class="flex-grow text-base-90"
          >
            Help Centre
          </span>
          <aha-icon class="text-base-70" name="open-new-window" />
        </a>
      </li>
    </ul>
  </aha-context-menu>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import EventBus from '@/eventBus'
import utils from '@/util'
import gaCategories from '@/constant/gaCategories'

const iconOpenLink = require('@/assets/images/vector.svg')

export default {
  data: () => ({
    tooltipHelp: {
      content: `<img src="${iconOpenLink}" class="inline-block relative -top-0.5"></i> This link opens in a new tab`,
    },
  }),
  computed: {
    ...mapGetters(['isBackstage']),
    ...mapState({
      isPresenterWhiteLabel: (state) => state.isPresenterWhiteLabel,
      isGuestUser: (state) => state.currentUser.isGuest,
      presentation: (state) => state.presentation,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
      currentUser: (state) => state.currentUser,
    }),
    isInviteToEditVisible() {
      return this.currentUser.identifyProvider !== 'skoletube'
    },
  },
  mounted() {
    EventBus.$on('show-mobile-slide-up-menu', () => {
      if (!this.$refs['context-menu-actions']) return
      this.$refs['context-menu-actions'].show()
    })
  },
  methods: {
    handleSlideUpMenuClick(type, e) {
      if (type === 'private') {
        if (this.isDisableEditPresentation) {
          e.stopPropagation()
          return
        }
        this.$emit('switchPrivateMode')
      }
      if (type === 'rename') {
        if (this.isDisableEditPresentation) {
          e.stopPropagation()
          return
        }
        this._openEditPresentationName()
      }
      if (type === 'setting') {
        window.setTimeout(() => { // AHA-8942
          this.$emit('showSetting')
        }, 200)
      }
      if (type === 'results') {
        window.setTimeout(() => { // AHA-8942
          this.$emit('showExport')
        }, 200)
      }
      if (type === 'share') {
        window.setTimeout(() => { // AHA-8942
          this.$emit('showShare')
        }, 200)
      }
      if (type === 'shareToEdit') {
        this.$emit('showShareToEdit')
      }
    },

    _openEditPresentationName() {
      if (this.isDisableEditPresentation || this.isBackstage) return
      utils.gaTrackEvent(
        gaCategories.PRESENTATION_EDITOR,
        'Editor Header > Presentation Name > Toggle Edit',
      )

      setTimeout(() => {
        EventBus.$emit('open-edit-name')
      }, 1)
    },

    clickHelpContext() {
      utils.gaTrackEvent(gaCategories.PRESENTATION_EDITOR, 'ContextMenu > Help')
    },
  },
}
</script>
